import React from 'react';
import SubjectPage from '../structure/SubjectPage';

const Artificial_Intelligence = () => {
  const accordionContent = [
    <div key="1" className="p-4">
      <p>AI Definition, Problems, Techniques, Models, Defining Problem as a state space search, production system, Characteristics, Search methods and issues in the design of search problems.</p>
    </div>,
    <div key="2" className="p-4">
      <p>Knowledge representation issues, mapping, frame problem, Predicate logic, facts in logic, representing instance and Isa relationship, Resolution, procedural and declarative knowledge, matching, control knowledge, Symbolic reasoning under uncertainty, Non monotonic reasoning, statistical reasoning.</p>
    </div>,
    <div key="3" className="p-4">
      <p>Game Playing, minimax search, Alfa beta cut-offs, Natural Language Processing, Learning, Explanation-based learning, discovery, analogy, Neural net learning and Genetic Learning.</p>
    </div>,
    <div key="4" className="p-4">
      <p>Fuzzy logic systems, Perception and action, Expert systems, Inference in Bayesian Networks, K-means Clustering Algorithm, Machine learning.</p>
    </div>
  ];

  const tabData = [
    {
      id: 'syllabus',
      label: 'Syllabus',
      content: null,
    },
    {
      id: 'notes',
      label: 'Notes',
      content: null,
    },
    {
      id: 'important',
      label: 'Important Questions',
      content: null,
    },
    {
      id: 'books',
      label: 'Books',
      content: null,
    },
    {
      id: 'PYQ',
      label: 'PYQ',
      content: null,
    },
    {
      id: 'youtube_playlist',
      label: 'Video Lectures',
      content: null,
    },
  ];

  return (
    <SubjectPage
      subjectName="Artificial Intelligence"
      subjectKey="ai"
      accordionContent={accordionContent}
      tabData={tabData}
      adminEmail="snaped4338@gmail.com"
    />
  );
};

export default Artificial_Intelligence;